import React from 'react';
import { MapPin } from 'lucide-react';
export function ServiceAreaSection() {
  const areas = ['Toronto', 'Ottawa', 'Mississauga', 'Brampton', 'Hamilton', 'London', 'Markham', 'Vaughan', 'Kitchener', 'Windsor', 'Barrie', 'Simcoe County'];
  return <section className="py-16 bg-slate-900 text-white md:py-24" data-id="element-290">
      <div className="container mx-auto px-4 md:px-6" data-id="element-291">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-292">
          <div className="space-y-8" data-id="element-293">
            <h2 className="text-3xl font-bold tracking-tight sm:text-4xl" data-id="element-294">
              Proudly Serving All of Ontario
            </h2>
            <p className="text-lg text-slate-300" data-id="element-295">
              We are dedicated to helping our neighbors across the province
              manage the challenging Canadian winters. Our team is familiar with
              local climate conditions and building codes throughout Ontario.
            </p>

            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4" data-id="element-296">
              {areas.map((area, index) => <div key={index} className="flex items-center gap-2 text-slate-300" data-id="element-297">
                  <MapPin className="h-4 w-4 text-primary" data-id="element-298" />
                  <span data-id="element-299">{area}</span>
                </div>)}
            </div>

            <div className="p-6 bg-slate-800 rounded-lg border border-slate-700" data-id="element-300">
              <p className="font-medium text-white mb-2" data-id="element-301">
                Don't see your area?
              </p>
              <p className="text-sm text-slate-400" data-id="element-302">
                We often travel for larger projects. Contact us to see if we can
                service your property.
              </p>
            </div>
          </div>

          <div className="relative h-[400px] w-full rounded-2xl overflow-hidden bg-slate-800 shadow-xl border border-slate-700 group" data-id="element-303">
            {/* Map Image */}
            <img src="https://cdn.magicpatterns.com/uploads/wzK7WvRXNBLztZ3HxyzZqE/384760245_e12591d850_b-1024x683.jpg" alt="Spirit Catcher sculpture in Barrie winter" className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-304" />

            {/* Overlay for text readability */}
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-transparent to-transparent" data-id="element-305"></div>

            <div className="absolute bottom-0 left-0 right-0 p-6" data-id="element-306">
              <div className="flex items-center gap-2 text-white font-medium" data-id="element-307">
                <MapPin className="h-5 w-5 text-primary" data-id="element-308" />
                <span data-id="element-309">Serving Communities Across Ontario</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}